import React from 'react';
import { Box, MYOBLogo as FeelixMYOBLogo } from '@myob/myob-widgets';
import { FEELIX_THEMES } from '../../constants';
import style from './logo.module.scss';

interface MYOBLogoProps {
  theme: string;
}
export const MYOBLogo: React.FC<MYOBLogoProps> =
  ({
    theme
  }) => {
    if (![FEELIX_THEMES.MODERN, FEELIX_THEMES.PARTNER, FEELIX_THEMES.COMMON].includes(theme)) {
      return null;
    }

    return (
      <Box className={style.container} data-testid='myob-logo'>
        <FeelixMYOBLogo/>
      </Box>
    );
  };
